import { createSelector } from '@reduxjs/toolkit';
import { selectShippingRegionCountryCodeIso2 } from 'tradera/state/shipping-region/selectors';
import { isSwedenCountryCodeOrUndefined } from 'tradera/localization/countrycode';
import { selectPageType } from '../page/selectors';

export const selectDisplayCountyFilter = (state) => {
    return (
        isSwedenCountryCodeOrUndefined(
            selectShippingRegionCountryCodeIso2(state)
        ) && selectPageType(state) !== 'ProfilePage_items'
    );
};

export const selectSaveSearchData = createSelector(
    (state) => state.discover,
    ({
        queryParams,
        currentCategoryId,
        headerText,
        totalItems,
        isSavedSearchEmailEnabled
    }) => ({
        searchName: queryParams?.q || headerText,
        categoryId: currentCategoryId,
        queryParams,
        totalItems,
        isSavedSearchEmailEnabled
    })
);

export const selectItemConditionFilter = (state) =>
    state.discover.filters.itemCondition;

export const selectSellerTypeFilter = (state) =>
    state.discover.filters.sellerType;

export const selectCountyFilter = (state) => state.discover.filters.county;

export const selectItemTypeFilter = (state) => state.discover.filters.itemType;

export const selectSortByFilter = (state) => state.discover.filters.sortBy;

export const selectAllowedBuyerRegionsFilter = (state) =>
    state.discover.filters.allowedBuyerRegions;

export const selectItemStatusFilter = (state) => {
    const itemStatus = state.discover.filters.itemStatus;
    const includeUnsoldOption =
        state.environment.featureSwitches['search-item-status-unsold'];

    if (includeUnsoldOption || !itemStatus) {
        return itemStatus;
    }

    return {
        ...itemStatus,
        options: itemStatus.options.flatMap((option) =>
            option.value === 'Unsold' ? [] : [option]
        )
    };
};
